import { useIntl } from 'react-intl'

import type { TagOverflowProps } from './TagOverflow.types'

export const TagOverflow = (props: TagOverflowProps) => {
  const { count, onClick } = props
  const intl = useIntl()

  if (count <= 0) {
    return null
  }

  return (
    <button
      aria-label={intl.formatMessage({ id: 'Tags_show_more' }, { count })}
      className="TagBadge TagBadge--overflow"
      onClick={onClick}
      type="button"
    >
      +{count}
    </button>
  )
}
